import { IconProps } from '@phosphor-icons/react';

export const BellIcon = ({ size = 16, height, color = '#475569', ...rest }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.9994 2C7.79158 2 4.19766 5.17264 3.74939 9.35647L2.98555 14.3328C2.72989 15.9983 4.01866 17.5 5.70371 17.5H18.2951C19.9801 17.5 21.2689 15.9983 21.0132 14.3328L20.2494 9.35648C19.8011 5.17264 16.2071 2 11.9994 2Z"
            fill={color}
        />
        <path
            d="M16.5839 19H7.41602C8.18758 20.7659 9.94966 22 12 22C14.0503 22 15.8124 20.7659 16.5839 19Z"
            fill={color}
        />
    </svg>
);
